import { useState } from "react";
import { Facebook, MessageCircle, Eye } from "lucide-react";
import { adShareUrl } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { QuickSightingDialog } from "./QuickSightingDialog";

const enc = encodeURIComponent;

export function LostCardActions({ listing }) {
  const { user, setAuthOpen } = useAuth();
  const { t, lang } = useLanguage();
  const [open, setOpen] = useState(false);
  const url = adShareUrl(listing, lang);
  const stop = (fn) => (e) => { e.preventDefault(); e.stopPropagation(); fn(); };
  const popup = (href) => window.open(href, "_blank", "noopener,noreferrer");
  const own = user && user.user_id === listing.user_id;
  const btn = "h-9 rounded-xl flex items-center justify-center gap-1.5 text-xs font-semibold transition-colors";

  return (
    <div onClick={(e) => e.stopPropagation()} className="mt-3 pt-3 border-t border-slate-100 flex items-center gap-2" data-testid={`lost-actions-${listing.id}`}>
      {!own && (
        <button type="button" onClick={stop(() => (user ? setOpen(true) : setAuthOpen(true)))} data-testid={`quick-sighting-btn-${listing.id}`}
          className={`${btn} flex-1 bg-red-600 hover:bg-red-700 text-white`}>
          <Eye size={15} /> {t("sg_report")}
        </button>
      )}
      <button type="button" onClick={stop(() => popup(`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`))} aria-label={t("qs_share_fb")} title={t("qs_share_fb")}
        data-testid={`lost-share-fb-${listing.id}`} className={`${btn} ${own ? "flex-1" : "w-9"} bg-[#1877F2]/10 hover:bg-[#1877F2]/20 text-[#1877F2]`}>
        <Facebook size={15} />{own && " Facebook"}
      </button>
      <button type="button" onClick={stop(() => popup(`https://wa.me/?text=${enc(`${t("qs_help")}: ${listing.title} ${url}`)}`))} aria-label={t("qs_share_wa")} title={t("qs_share_wa")}
        data-testid={`lost-share-wa-${listing.id}`} className={`${btn} ${own ? "flex-1" : "w-9"} bg-[#25D366]/10 hover:bg-[#25D366]/20 text-[#128C4A]`}>
        <MessageCircle size={15} />{own && " WhatsApp"}
      </button>
      <QuickSightingDialog listing={listing} open={open} onOpenChange={setOpen} />
    </div>
  );
}
